import { Component } from 'react';
import { USER_ROLES } from '../../../_shared/constants';
import { ml } from 'src/_shared/services/utils';

class SendReferralCard extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	handleBrowseJobs = (id) => {
		if (id) {
			this.props.history.push(`/browsejobs/${id}`);
		} else {
			this.props.history.push('/browsejobs');
		}
	};

	render() {
		const {
			allMultiLingualData,
			currentUser,
			background,
			referralCardButton,
			referralCardSubheader,
			referralCardHeader,
			textColor,
		} = this.props;

		return (
			<>
				{(currentUser.displayAs === USER_ROLES.EMPLOYEE ||
					currentUser.role === USER_ROLES.MANAGER) && (
					<div className="e-card-wrap" style={{ backgroundColor: background }}>
						<div className="e-card-title" style={{ color: textColor }}>
							{ml(referralCardHeader, currentUser, allMultiLingualData)}
						</div>
						<div className="e-card-subtitle" style={{ color: textColor }}>
							{ml(referralCardSubheader, currentUser, allMultiLingualData)}
						</div>
						<button
							type="button"
							className="c-btn-white"
							onClick={() => {
								this.handleBrowseJobs();
							}}
						>
							{ml(referralCardButton, currentUser, allMultiLingualData)}
						</button>
					</div>
				)}
			</>
		);
	}
}
export const SendReferral = SendReferralCard;
